module.exports = __webpack_public_path__ + "assets/img/typeIcon-1-yellow.07c4d102.svg";